/**
 * Visibilidad de elementos server-rendered que React necesita alternar sin
 * recargar la página (p. ej. el header de llamadas). Framework-agnóstico.
 */

const HIDDEN_CLASS = 'd-none';

/**
 * Aplica/remueve el estado oculto sobre un elemento ya resuelto.
 *
 * Usa `display: none !important` inline porque las utilidades Bootstrap
 * `d-inline-flex` / `d-inline-block` también son `!important` y ganarían a
 * `d-none` (misma especificidad, declaradas después) y al inline sin `!important`.
 *
 * @param {{ classList?: { add: Function, remove: Function }, style?: object }|null} el
 * @param {boolean} hidden
 * @returns {boolean} true si se manipuló un elemento.
 */
export function setHiddenAttribute(el, hidden) {
  if (!el) return false;

  if (hidden) {
    el.classList?.add(HIDDEN_CLASS);
    if (el.style) {
      if (typeof el.style.setProperty === 'function') {
        el.style.setProperty('display', 'none', 'important');
      } else {
        Object.assign(el.style, { display: 'none' });
      }
    }
  } else {
    el.classList?.remove(HIDDEN_CLASS);
    if (el.style) {
      if (typeof el.style.removeProperty === 'function') {
        el.style.removeProperty('display');
      } else {
        Object.assign(el.style, { display: '' });
      }
    }
  }

  return true;
}

/**
 * Alterna la visibilidad del elemento con `id` (no-op si no existe o sin DOM).
 * @param {string} id
 * @param {boolean} hidden
 * @returns {boolean} true si se manipuló un elemento.
 */
export function setElementHidden(id, hidden) {
  if (typeof document === 'undefined' || !id) return false;

  return setHiddenAttribute(document.getElementById(id), hidden);
}
